import React from 'react';

import * as S from 'src/modules/programs/stepComponents/styles';
import stepIcon from 'src/public/img/undraw-celebration-0-jvk.svg';

export const DevelopingFlexibilityStep = () => (
    <>
        <S.ContentRow>
            <S.ContentColumn>
                <S.StepHeading small>Flexibility</S.StepHeading>
                <S.StepHeading>Developing Flexibility</S.StepHeading>
            </S.ContentColumn>
        </S.ContentRow>
        <S.ContentRow>
            <S.ContentColumn md={14}>
                <S.StepDescription small>
                    Low psychological flexibility has been associated with lots of things, including
                    anxiety, depression, poor work performance, and lower quality of life. So, now
                    that you are convinced that psychological flexibility is important - how do we
                    get it? The good news is that it’s a skill that we can develop over time. One
                    great way is to do something we have already started: mindfulness. As you sit
                    and practice mindfulness meditation, you are learning how to stay with the
                    present moment non-judgmentally. Everytime you notice that your thoughts have
                    strayed and you bring your awareness back to your breath, you are developing
                    flexibility! You are learning that you don’t have to just do what your thoughts
                    tell you, you can choose to come back to the breath, or to another point of
                    focus. Same thing with emotions, you might notice that you get bored or
                    frustrated during a meditation - you can practice noticing that emotion and then
                    choosing what to do based on your values - maybe you stop if that’s what you
                    really want to do, and maybe you just notice that and keep going. Practicing
                    mindfulness means that you can take a breath and learn to respond instead of
                    just reacting.
                </S.StepDescription>
                <S.StepDescription small>
                    Two other ways of developing flexibility have to do with changing our
                    relationship to our <S.Strong>thoughts</S.Strong> and{' '}
                    <S.Strong>emotions!</S.Strong>
                </S.StepDescription>
            </S.ContentColumn>
            <S.ContentColumn md={10}>
                <S.StepIcon iconUrl={stepIcon} />
            </S.ContentColumn>
        </S.ContentRow>
    </>
);
